import { createContext, useContext, useEffect, useState, useCallback } from "react";
import apiClient from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem("bf_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await apiClient.get("/api/auth/me");
      setUser(data);
      localStorage.setItem("bf_user", JSON.stringify(data));
    } catch {
      setUser(null);
      localStorage.removeItem("bf_token");
      localStorage.removeItem("bf_user");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await apiClient.post("/api/auth/login", { email, password });
    localStorage.setItem("bf_token", data.access_token);
    localStorage.setItem("bf_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const googleLogin = async (sessionId) => {
    const { data } = await apiClient.post("/api/auth/google", null, { headers: { "X-Session-ID": sessionId } });
    localStorage.setItem("bf_token", data.access_token);
    localStorage.setItem("bf_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await apiClient.post("/api/auth/logout");
    } catch {
      /* ignore */
    }
    localStorage.removeItem("bf_token");
    localStorage.removeItem("bf_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, googleLogin, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
